import React from 'react';

class SelectableUser extends React.Component {

    state = {
        user: null
    }

    componentWillMount() {
        this.setState({ user: this.props.user });
    }

    render() {
        const { user } = this.state;
        return (<figure className={`d-flex flex-row margin-top-half ${!user.Token ? 'bg-gray w-100' : null}`}>

            <div className="user-avatar-rounded cover align-self-centger"
                style={{ background: `url(${user.CURRENT_IMAGE_80}) no-repeat center center black` }} />

            <div className="d-flex flex-column align-self-center idented justify-content-start">
                <span className="font-14 no-margin no-padding ">{[user.NameFirst, user.NameLast].join(' ')}</span>
                {(user.IsLeagueAdmin || user.IsAdmin) && <span className="blue no-padding no-margin text-left">Club Admin</span>}
            </div>

            {!user.Token && <i className="fa ml-auto fa-exclamation-triangle red margin-right-half align-self-center" />}
        </figure>)
    }
}

export default SelectableUser;